// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "9b0008ae" + "." + "4c10a7b1799fe86b" + ".js";
};